import { h } from "preact";

import IconProps from "./IconProps";

function IconDivider({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 14 14">
            <g fill={color} fill-rule="evenodd">
                <circle cx="7" cy="12" r="2"/>
                <circle cx="7" cy="2" r="2"/>
                <rect width="14" height="2" y="6" rx="1"/>
            </g>
        </svg>
    );
}

IconDivider.defaultProps = {
    color: "var(--cornflower-blue)",
    width: 14,
    height: 14
};

export default IconDivider;
